import articlesMenuNavigate from "../functions/articlesMenuNavigate";
import initializeFacebookLikeButton from "../functions/initializeFacebookLikeButton";
import initializeTwitterFollowButton from "../functions/initializeTwitterFollowButton";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.articles.show").length) return;
  articlesMenuNavigate();
  initializeFacebookLikeButton(gon.user_facebook_url);
  initializeTwitterFollowButton(gon.user_twitter_account);
});
